jQuery(document).ready(() => {

	const menu_container = jQuery(`[data-navbar='menu-level-1']`);

	/**
	 * Background Behavior
	 */
	const navbar_bgr = jQuery(`[data-navbar='bgr']`);
	navbar_bgr.click(bgrOnClik);





	/**
	 * Show Menu Level 2
	 */
	const items_level_1 = jQuery(`[data-navbar='i-level-1']`);
	jQuery.each(items_level_1, function () {
		jQuery(this).click((e) => {
			e.preventDefault();
			jQuery(this).showLevel({
				level: 2
			});
		});
	});





	/**
	 * Hide Menu Level 2
	 */
	const back_level_2 = jQuery(`[data-navbar='back-level-2']`);
	jQuery.each(back_level_2, function () {
		jQuery(this).click((e) => {
			e.preventDefault();
			const nav_box = jQuery(this).parent().parent();
			const nav_box_children = nav_box.find('.box-items__l-3.active');
			nav_box.hideLevel({
				level: 2
			});
			nav_box_children.hideLevel({
				level: 3
			});
		});
	});





	/**
	 * Show Menu Level 3
	 */
	const items_level_2 = jQuery(`[data-navbar='i-level-2']`);
	jQuery.each(items_level_2, function () {
		jQuery(this).click((e) => {
			e.preventDefault();
			jQuery(this).showLevel({
				level: 3
			});
		});
	});





	/**
	 * Hide Menu Level 3
	 */
	const back_level_3 = jQuery(`[data-navbar='back-level-3']`);
	jQuery.each(back_level_3, function () {
		jQuery(this).click((e) => {
			e.preventDefault();
			const nav_box = jQuery(this).parent().parent();
			nav_box.hideLevel({
				level: 3
			});
		});
	});





	/**
	 * Icon Burger Behavior
	 */
	const nav_burger = jQuery(`[data-navbar='icon']`);
	const icon_nav_mb = nav_burger.find('.icon-nav');
	const status_nav = nav_burger.find('.nav-status');

	nav_burger.click(() => {
		if (menu_container.hasClass('active')) {
			menuDesactive();
			hideSelectLevels(2);
			hideSelectLevels(3);
		} else {
			menuActive();
		}
	});





	/**
	 * Verify Resize Device
	 */
	navBarOnResize();
	showOrHideBox();
	navBarStatus();

	jQuery(window).resize(function () {
		navBarOnResize();
		showOrHideBgr();
		showOrHideBox();
		navBarStatus();
	});





	/**
	 * Navbar Behavior on Resize
	 */
	function navBarOnResize() {
		const width = jQuery(window).width();
		hideSelectLevels(2);
		hideSelectLevels(3);

		if (width < 992) {
			showAllItems();
			//menuDesactive();
		} else {
			hideAllItems();
		}
	}





	/**
	 * Event Background on click
	 */
	function bgrOnClik() {
		let control = 2;
		const levels_2 = jQuery('.box-items__l-2.active');
		const levels_3 = jQuery('.box-items__l-3.active');
	
		if (levels_3.hasClass('active')) {
			levels_3.hideLevel({
				level: 3
			});

			control = 3;
		}

		if (control === 2) {
			if (levels_2.hasClass('active')) {
				levels_2.hideLevel({
					level: 2
				});
			}
		}
	}





	/**
	 * Active Menu Level 1
	 */
	function menuActive() {
		const width = getWidthWindow();
		const space_navbar = jQuery('.navbar-space');

		if (menu_container.hasClass('active') === false) {
			menu_container.addClass('active');
			icon_nav_mb.children().addClass('active');
			status_nav.text('Esconder');
			space_navbar.addClass('displaced');
			
			if (width < 992) {
				jQuery('body').addClass('scroll-hidden');
			} else {
				jQuery('body').removeClass('scroll-hidden');
			}
		}
	}





	/**
	 * Desactive Menu Level 1
	 */
	function menuDesactive() {
		const space_navbar = jQuery('.navbar-space');

		navbar_bgr.removeClass('active');

		if (menu_container.hasClass('active')) {
			menu_container.removeClass('active');
			icon_nav_mb.children().removeClass('active');
			status_nav.text('Menú');
			space_navbar.removeClass('displaced');
			jQuery('body').removeClass('scroll-hidden');
		}
	}





	/**
	 * Show Level
	 * @param {*} options 
	 */
	jQuery.fn.showLevel = function (options) {
		const config = jQuery.extend({
			level: 0,
			time: 150
		}, options);

		const width = getWidthWindow();

		const nav_box = jQuery(this).siblings(`.box-items__l-${config.level}`);
		const nav_box_items = nav_box.children(`.box-i-level-${config.level}`);
		const nav_back = nav_box.children(`.box-bton-back-${config.level}`);

		if (config.level === 2) {
			hideSelectLevels(config.level);
			hideSelectLevels(config.level + 1);
		} else {
			hideSelectLevels(config.level);
		}
		
		if (width < 992) {
			nav_box.addClass('active');
		} else {
			nav_box.addClass('active');
			showItems([nav_box_items, nav_back], config.time);
			animateItemsOn([nav_box_items, nav_back]);
		}

		showOrHideBgr();
	}





	/**
	 * Hide Level
	 * @param {*} options 
	 */
	jQuery.fn.hideLevel = function (options) {
		const config = jQuery.extend({
			level: 0
		}, options);

		const width = getWidthWindow();

		const nav_box_items = jQuery(this).children(`.box-i-level-${config.level}`);
		const nav_back = jQuery(this).children(`.box-bton-back-${config.level}`);

		jQuery(this).removeClass('active');

		if (width < 992) {
			showItems([nav_box_items, nav_back]);
			animateItemsOn([nav_box_items, nav_back]);
		} else {
			hideItems([nav_box_items, nav_back]);
			animateItemsOff([nav_box_items, nav_back]);
		}

		showOrHideBgr();
	}





	/**
	 * Hide Level Selected 
	 * @param {*} level 
	 */
	function hideSelectLevels(level) {
		const width = getWidthWindow();

		if (!level || level === undefined) return;

		const level_last = jQuery(`[data-navbar='i-level-${level - 1}']`);

		jQuery.each(level_last, function () {
			const nav_box = jQuery(this).siblings(`.box-items__l-${level}`);
			const nav_box_items = nav_box.children(`.box-i-level-${level}`);
			const nav_back = nav_box.children(`.box-bton-back-${level}`);
	
			if (width < 992) {
				nav_box.removeClass('active');
			} else {
				nav_box.removeClass('active');	
				hideItems([nav_box_items, nav_back]);
				animateItemsOff([nav_box_items, nav_back]);
			}
		});
		
	}





	/**
	 * Show Items
	 * @param {*} arraySelector 
	 * @param {*} time 
	 */
	function showItems(arraySelector, time) {
		if (arraySelector.length < 1 || !arraySelector) return;
		
		jQuery.each(arraySelector, function () {
			jQuery(this).show(time);
		});
	}





	/**
	 * Show All Items
	 */
	function showAllItems() {
		jQuery('.box-i-level-2').css({ opacity: 1, display: 'block' });
		jQuery('.box-i-level-3').css({ opacity: 1, display: 'block' });
		jQuery('.box-bton-back-2').css({ opacity: 1, display: 'block' });
		jQuery('.box-bton-back-3').css({ opacity: 1, display: 'block' });
	}





	/**
	 * Hide Items
	 * @param {*} arraySelector 
	 */
	function hideItems(arraySelector) {
		if (arraySelector.length < 1 || !arraySelector) return;

		jQuery.each(arraySelector, function () {
			jQuery(this).hide();
		});
	}





	/**
	 * Hide All Items
	 */
	function hideAllItems() {
		jQuery('.box-i-level-2').css({ opacity: 0, display: 'none' });
		jQuery('.box-i-level-3').css({ opacity: 0, display: 'none' });
		jQuery('.box-bton-back-2').css({ opacity: 0, display: 'none' });
		jQuery('.box-bton-back-3').css({ opacity: 0, display: 'none' });
	}






	/**
	 * Animate On Items
	 * @param {*} arraySelector 
	 */
	function animateItemsOn(arraySelector) {
		if (arraySelector.length < 1 || !arraySelector) return;

		jQuery.each(arraySelector, function () {
			jQuery(this).animate({
				opacity: 1
			}, 400);
		});
	}





	/**
	 * Animate Off Items
	 * @param {*} arraySelector 
	 */
	function animateItemsOff(arraySelector) {
		if (arraySelector.length < 1 || !arraySelector) return;

		jQuery.each(arraySelector, function () {
			jQuery(this).animate({
				opacity: 0
			}, 100);
		});
	}





	/**
	 * Background Behavior
	 */
	function showOrHideBgr() {
		const levels_2 = jQuery('.box-items__l-2');
		const levels_3 = jQuery('.box-items__l-3');
	
		if (levels_2.hasClass('active') || levels_3.hasClass('active')) {
			navbar_bgr.addClass('active');
		} else {
			navbar_bgr.removeClass('active');
		}
	}





	/**
	 * Show or Hide Menu Box
	 */
	function showOrHideBox() {
		const width = getWidthWindow();

		if (width < 992) {
			menuDesactive();
		} else {
			menuActive();
		}
	}





	/**
	 * Status Navbar
	 */
	function navBarStatus() {
		if (menu_container.hasClass('active')) {
			status_nav.text('Esconder');
			icon_nav_mb.children().addClass('active');
		} else {
			status_nav.text('Menú');
			icon_nav_mb.children().removeClass('active');
		}
	}





	/**
	 * Get Width on Resize
	 */
	function getWidthWindow() {
		let width = jQuery(window).width();
		jQuery(window).resize(() => {
			width = jQuery(window).width();
			return width;
		});

		return width;
	}
});